export const qualYearSelect = state => state.contract_globals.qualification_year;

export const apptTypesSelect = state => state.contract_globals.appointment_types;